<template>
  <div class="q-px-md">
    <div>
      <h5 class="text-bold q-pt-lg q-pb-md text-center">
        Want more information?
      </h5>
      <div class="row q-col-gutter-sm justify-center">
        <div class="col-6">
          <SAIBtn
            class="full-width"
            outline
            no-caps
            padding="12px sm"
            type="a"
            :href="`tel:${contactNumber}`"
            :label="contactNumber"
            icon="eva-phone-outline"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SAIBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'MoreInformation',
  props: {
    contactNumber: String
  },
  components: {
    SAIBtn
  }
};
</script>
